var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.profile_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button")],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _vm.ProfilList.length > 0
            ? [
                _c("div", { staticClass: "title-label-blue w-200px" }, [
                  _vm._v(_vm._s(_vm.$t("administration.user_info"))),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { staticClass: "text-center w-50" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("administration.label")) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center w-50" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.ProfilList[0].libelle) +
                            "\n              "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "title-label-blue w-200px" }, [
                  _vm._v(_vm._s(_vm.$t("administration.right"))),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table text-center" }, [
                  _c("thead", [
                    _c("th", [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("administration.right_list")) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm.ProfilList.length > 0
                        ? _vm._l(_vm.ProfilList[0].rights, function (result) {
                            return _c("tr", { staticClass: "boxRequest" }, [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "rights.db_rights." + result.Libelle
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "rights.db_rights." + result.Libelle
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ])
                          })
                        : _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "noResult",
                                attrs: { colspan: "6" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.canProfileEdit || _vm.canProfileDelete
            ? _c("b-row", { staticClass: "justify-content-end no-gutters" }, [
                _vm.canProfileDelete
                  ? _c(
                      "div",
                      { staticClass: "deleteUser" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function ($event) {
                                return _vm.activateDelete(
                                  _vm.ProfilList[0].id_rights_profile
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-trash" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("administration.profile_delete")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }